import { Box, type BoxProps, Container, type ContainerProps, type Theme, useMediaQuery } from '@mui/material';
import 'driver.js/dist/driver.css';
import type Header from '../header';
import type HeroHeader from '../hero-header';

const PageContainer = ({
    boxChildren,
    heroHeader,
    header,
    children,
    boxProps,
    containerProps,
}: {
    boxChildren?: React.ReactNode;
    heroHeader?: ReturnType<typeof HeroHeader>;
    header?: ReturnType<typeof Header>;
    boxProps?: BoxProps;
    containerProps?: ContainerProps;
    children: React.ReactNode;
}) => {
    const isXsOrLower = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    return (
        <Box {...boxProps}>
            {heroHeader && heroHeader}
            {boxChildren && boxChildren}
            <Container maxWidth={'xl'} sx={[isXsOrLower ? { pt: 2, pb: 2 } : { pt: 5, pb: 2 }]} {...containerProps}>
                {header && header}
                {children}
            </Container>
        </Box>
    );
};

export default PageContainer;
